// studio swing with values 16-235
// RGB_Y(r,g,b) floor(((66*r + 129*g +  25*b + 128) >> 8) +  16)
// RGB_U(r,g,b) floor(((-38*r - 74*g + 112*b + 128) >> 8) + 128)
// RGB_V(r,g,b) floor(((112*r - 94*g -  18*b + 128) >> 8) + 128)

// CLAMP(x) (x<0?0:x>255?255:x)
// YUV_R(y,u,v) CLAMP((298*(y-16) + 409*(v-128) + 128) >> 8)
// YUV_G(y,u,v) CLAMP((298*(y-16) - 100*(u-128) - 208*(v-128) + 128) >> 8)
// YUV_B(y,u,v) CLAMP((298*(y-16) + 516*(u-128) + 128) >> 8)

const COLORS = {
  aliceblue: [0xF0, 0xF8, 0xFF],
  antiquewhite: [0xFA, 0xEB, 0xD7],
  aqua: [0x00, 0xFF, 0xFF],
  aquamarine: [0x7F, 0xFF, 0xD4],
  azure: [0xF0, 0xFF, 0xFF],
  beige: [0xF5, 0xF5, 0xDC],
  bisque: [0xFF, 0xE4, 0xC4],
  black: [0x00, 0x00, 0x00],
  blanchedalmond: [0xFF, 0xEB, 0xCD],
  blue: [0x00, 0x00, 0xFF],
  blueviolet: [0x8A, 0x2B, 0xE2],
  brown: [0xA5, 0x2A, 0x2A],
  burlywood: [0xDE, 0xB8, 0x87],
  cadetblue: [0x5F, 0x9E, 0xA0],
  chartreuse: [0x7F, 0xFF, 0x00],
  chocolate: [0xD2, 0x69, 0x1E],
  coral: [0xFF, 0x7F, 0x50],
  cornflowerblue: [0x64, 0x95, 0xED],
  cornsilk: [0xFF, 0xF8, 0xDC],
  crimson: [0xDC, 0x14, 0x3C],
  cyan: [0x00, 0xFF, 0xFF],
  darkblue: [0x00, 0x00, 0x8B],
  darkcyan: [0x00, 0x8B, 0x8B],
  darkgoldenrod: [0xB8, 0x86, 0x0B],
  darkgray: [0xA9, 0xA9, 0xA9],
  darkgreen: [0x00, 0x64, 0x00],
  darkkhaki: [0xBD, 0xB7, 0x6B],
  darkmagenta: [0x8B, 0x00, 0x8B],
  darkolivegreen: [0x55, 0x6B, 0x2F],
  darkorange: [0xFF, 0x8C, 0x00],
  darkorchid: [0x99, 0x32, 0xCC],
  darkred: [0x8B, 0x00, 0x00],
  darksalmon: [0xE9, 0x96, 0x7A],
  darkseagreen: [0x8F, 0xBC, 0x8F],
  darkslateblue: [0x48, 0x3D, 0x8B],
  darkslategray: [0x2F, 0x4F, 0x4F],
  darkturquoise: [0x00, 0xCE, 0xD1],
  darkviolet: [0x94, 0x00, 0xD3],
  deeppink: [0xFF, 0x14, 0x93],
  deepskyblue: [0x00, 0xBF, 0xFF],
  dimgray: [0x69, 0x69, 0x69],
  dodgerblue: [0x1E, 0x90, 0xFF],
  firebrick: [0xB2, 0x22, 0x22],
  floralwhite: [0xFF, 0xFA, 0xF0],
  forestgreen: [0x22, 0x8B, 0x22],
  fuchsia: [0xFF, 0x00, 0xFF],
  gainsboro: [0xDC, 0xDC, 0xDC],
  ghostwhite: [0xF8, 0xF8, 0xFF],
  gold: [0xFF, 0xD7, 0x00],
  goldenrod: [0xDA, 0xA5, 0x20],
  gray: [0x80, 0x80, 0x80],
  green: [0x00, 0x80, 0x00],
  greenyellow: [0xAD, 0xFF, 0x2F],
  honeydew: [0xF0, 0xFF, 0xF0],
  hotpink: [0xFF, 0x69, 0xB4],
  indianred: [0xCD, 0x5C, 0x5C],
  indigo: [0x4B, 0x00, 0x82],
  ivory: [0xFF, 0xFF, 0xF0],
  khaki: [0xF0, 0xE6, 0x8C],
  lavender: [0xE6, 0xE6, 0xFA],
  lavenderblush: [0xFF, 0xF0, 0xF5],
  lawngreen: [0x7C, 0xFC, 0x00],
  lemonchiffon: [0xFF, 0xFA, 0xCD],
  lightblue: [0xAD, 0xD8, 0xE6],
  lightcoral: [0xF0, 0x80, 0x80],
  lightcyan: [0xE0, 0xFF, 0xFF],
  lightgoldenrodyellow: [0xFA, 0xFA, 0xD2],
  lightgreen: [0x90, 0xEE, 0x90],
  lightgrey: [0xD3, 0xD3, 0xD3],
  lightpink: [0xFF, 0xB6, 0xC1],
  lightsalmon: [0xFF, 0xA0, 0x7A],
  lightseagreen: [0x20, 0xB2, 0xAA],
  lightskyblue: [0x87, 0xCE, 0xFA],
  lightslategray: [0x77, 0x88, 0x99],
  lightsteelblue: [0xB0, 0xC4, 0xDE],
  lightyellow: [0xFF, 0xFF, 0xE0],
  lime: [0x00, 0xFF, 0x00],
  limegreen: [0x32, 0xCD, 0x32],
  linen: [0xFA, 0xF0, 0xE6],
  magenta: [0xFF, 0x00, 0xFF],
  maroon: [0x80, 0x00, 0x00],
  mediumaquamarine: [0x66, 0xCD, 0xAA],
  mediumblue: [0x00, 0x00, 0xCD],
  mediumorchid: [0xBA, 0x55, 0xD3],
  mediumpurple: [0x93, 0x70, 0xD8],
  mediumseagreen: [0x3C, 0xB3, 0x71],
  mediumslateblue: [0x7B, 0x68, 0xEE],
  mediumspringgreen: [0x00, 0xFA, 0x9A],
  mediumturquoise: [0x48, 0xD1, 0xCC],
  mediumvioletred: [0xC7, 0x15, 0x85],
  midnightblue: [0x19, 0x19, 0x70],
  mintcream: [0xF5, 0xFF, 0xFA],
  mistyrose: [0xFF, 0xE4, 0xE1],
  moccasin: [0xFF, 0xE4, 0xB5],
  navajowhite: [0xFF, 0xDE, 0xAD],
  navy: [0x00, 0x00, 0x80],
  oldlace: [0xFD, 0xF5, 0xE6],
  olive: [0x80, 0x80, 0x00],
  olivedrab: [0x6B, 0x8E, 0x23],
  orange: [0xFF, 0xA5, 0x00],
  orangered: [0xFF, 0x45, 0x00],
  orchid: [0xDA, 0x70, 0xD6],
  palegoldenrod: [0xEE, 0xE8, 0xAA],
  palegreen: [0x98, 0xFB, 0x98],
  paleturquoise: [0xAF, 0xEE, 0xEE],
  palevioletred: [0xD8, 0x70, 0x93],
  papayawhip: [0xFF, 0xEF, 0xD5],
  peachpuff: [0xFF, 0xDA, 0xB9],
  peru: [0xCD, 0x85, 0x3F],
  pink: [0xFF, 0xC0, 0xCB],
  plum: [0xDD, 0xA0, 0xDD],
  powderblue: [0xB0, 0xE0, 0xE6],
  purple: [0x80, 0x00, 0x80],
  red: [0xFF, 0x00, 0x00],
  rosybrown: [0xBC, 0x8F, 0x8F],
  royalblue: [0x41, 0x69, 0xE1],
  saddlebrown: [0x8B, 0x45, 0x13],
  salmon: [0xFA, 0x80, 0x72],
  sandybrown: [0xF4, 0xA4, 0x60],
  seagreen: [0x2E, 0x8B, 0x57],
  seashell: [0xFF, 0xF5, 0xEE],
  sienna: [0xA0, 0x52, 0x2D],
  silver: [0xC0, 0xC0, 0xC0],
  skyblue: [0x87, 0xCE, 0xEB],
  slateblue: [0x6A, 0x5A, 0xCD],
  slategray: [0x70, 0x80, 0x90],
  snow: [0xFF, 0xFA, 0xFA],
  springgreen: [0x00, 0xFF, 0x7F],
  steelblue: [0x46, 0x82, 0xB4],
  tan: [0xD2, 0xB4, 0x8C],
  teal: [0x00, 0x80, 0x80],
  thistle: [0xD8, 0xBF, 0xD8],
  tomato: [0xFF, 0x63, 0x47],
  turquoise: [0x40, 0xE0, 0xD0],
  violet: [0xEE, 0x82, 0xEE],
  wheat: [0xF5, 0xDE, 0xB3],
  white: [0xFF, 0xFF, 0xFF],
  whitesmoke: [0xF5, 0xF5, 0xF5],
  yellow: [0xFF, 0xFF, 0x00],
  yellowgreen: [0x9A, 0xCD, 0x32],
}

function degreeDiff(hue1, hue2) {
  // useful also for hue difference
  const diff = Math.abs(hue1 - hue2) % 360
  return Math.min(diff, 360 - diff)
} // degreeDiff

function radAvg(...angles) {
  let sumX = 0
  let sumY = 0
  for(const angle of angles) {
    sumX += Math.cos(angle)
    sumY += Math.sin(angle)
  }
  const radAvg = Math.atan2(sumY, sumX)
  return radAvg<0 ? radAvg + 2*Math.PI : radAvg
} // radAvg

function degAvg(...angles) {
  angles = angles.map(a=>a/180*Math.PI)
  return radAvg(...angles)*180/Math.PI
} // degAvg

function rgb2hsl(r, g, b, round) {
  r /= 255
  g /= 255
  b /= 255
  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  const l = (max + min) / 2
  if(max === min) return [0, 0, l] // achromatic
  const diff = max - min
  const s = diff / (l > 0.5 ? (2 - max - min) : (max + min))
  let h = (
    max===r ? (g - b) / diff + (g < b ? 6 : 0) :
      max===g ? (b - r) / diff + 2 :
        (r - g) / diff + 4
  ) * 60
  if(round) h = Math.round(h)
  // s = (r*3 + g*4 + b) >> 3

  return [h, s, l]
} // rgb2hsl

function matrixRgbToHsl(src) {
  const { width, height, kind } = src
  const planes = kind==='rgba' ? 4 : 3
  const pixels3 = width * height * 3
  const dst = new Array(pixels3)
  for(let i=0, j=0; i<pixels3; i+=3, j+=planes) {
    const [h, s, l] = rgb2hsl(src[j], src[j+1], src[j+2])
    dst[i] = h // hue is 0-360 degrees
    dst[i+1] = s // saturation is 0-1
    dst[i+2] = l // lightness is 0-1
  }
  dst.width = src.width
  dst.height = src.height
  dst.kind = 'hsl'
  return dst
} // matrixRgbToHsl

function matrixToXys(src) {
  const planes = src.kind==='rgba' ? 4 : 3
  const pixels3 = Math.floor(src.length / planes) * 3
  const dst = new Array(pixels3)
  for(let i=0, j=0; i<pixels3; i+=3, j+=planes) {
    const [h, s, l] = rgb2hsl(src[j], src[j+1], src[j+2])
    const x = 255 * l * Math.cos(h)
    const y = 255 * l * Math.sin(h)
    dst[i] = x
    dst[i+1] = y
    dst[i+2] = 255 * s
  }
  dst.width = src.width
  dst.height = src.height
  dst.kind = 'xys'
  return dst
} // matrixToXys

function rgb2lab(r, g, b) {
  r /= 255.0
  g /= 255.0
  b /= 255.0

  // Gamma correction
  r = (r > 0.04045) ? Math.pow((r + 0.055) / 1.055, 2.4) : (r / 12.92)
  g = (g > 0.04045) ? Math.pow((g + 0.055) / 1.055, 2.4) : (g / 12.92)
  b = (b > 0.04045) ? Math.pow((b + 0.055) / 1.055, 2.4) : (b / 12.92)

  // Convert to XYZ
  let x = r * 0.4124564 + g * 0.3575761 + b * 0.1804375
  let y = r * 0.2126729 + g * 0.7151522 + b * 0.0721750
  let z = r * 0.0193339 + g * 0.1191920 + b * 0.9503041

  // Convert to CIELAB
  x /= 95.047
  y /= 100.000
  z /= 108.883

  x = (x > 0.008856) ? Math.pow(x, 1 / 3) : ((903.3 * x + 16) / 116)
  y = (y > 0.008856) ? Math.pow(y, 1 / 3) : ((903.3 * y + 16) / 116)
  z = (z > 0.008856) ? Math.pow(z, 1 / 3) : ((903.3 * z + 16) / 116)

  const L = Math.max(0, (116 * y) - 16)
  const A = (x - y) * 500
  const B = (y - z) * 200

  return [L, A, B]
} // rgb2lab

function matrixToLab(src) {
  const planes = src.kind==='rgba' ? 4 : 3
  const pixels3 = Math.floor(src.length / planes) * 3
  const dst = new Array(pixels3)
  for(let i=0, j=0; i<pixels3; i+=3, j+=planes) {
    const [l, a, b] = rgb2hsl(src[j], src[j+1], src[j+2])
    dst[i] = l
    dst[i+1] = a
    dst[i+2] = b
  }
  dst.width = src.width
  dst.height = src.height
  dst.kind = 'lab'
  return dst
} // matrixToLab

function hslDistance(a, b) {
  const [h1, s1, l1] = a
  const [h2, s2, l2] = b

  // Convert hue and saturation to Cartesian coordinates
  const x1 = l1 * Math.cos(h1)
  const y1 = l1 * Math.sin(h1)
  const x2 = l2 * Math.cos(h2)
  const y2 = l2 * Math.sin(h2)

  // Calculate Euclidean distance
  const distance = Math.sqrt((x2-x1)**2 + (y2-y1)**2 + (s2-s1)**2)

  return distance
} // hslDistance

function color2rgba(color) {
  function limit(x, base) {
    x = base ? parseInt(x, base) : parseInt(x)
    return x>255 ? 255 : x>0 ? x : 0
  }

  if(Array.isArray(color)) {
    const r = limit(color[0])
    const g = limit(color[1])
    const b = limit(color[2])
    const a = limit(color[3]) || 255
    return [r, g, b, a]
  }

  color = String(color??'')
  if(color==='') return null

  color = color.toLowerCase()
  if(COLORS[color]) return [...COLORS[color], 255]

  let m
  m = /^(?:#|0x)?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})?$/.exec(color)
  if(m) {
    const r = limit(m[1], 16)
    const g = limit(m[2], 16)
    const b = limit(m[3], 16)
    const a = limit(m[4], 16) || 255
    return [r, g, b, a]
  }

  m = /^(\d+),(\d+),(\d+)(?:,(\d+))$/i.exec(color)
  if(m) {
    const r = limit(m[1])
    const g = limit(m[2])
    const b = limit(m[3])
    const a = limit(m[4]) || 255
    return [r, g, b, a]
  }

  return null
} // color2rgba

const Color = {
  degreeDiff,
  radAvg,
  degAvg,
  rgb2hsl,
  rgb2lab,
  matrixRgbToHsl,
  matrixToXys,
  hslDistance,
  matrixToLab,
  color2rgba,
  COLORS,
  COLOR: COLORS,
}

if(typeof module!=='undefined') { module.exports = Color } else if(typeof window!=='undefined') { window.Color = Color }
